import React from "react";
import { Badge } from "../badge";

import { IconButton } from "../icon-button";

export enum BadgeType {
	"error",
	"warning",
}
interface IFloatingMenuButtonProps {
	onClick: () => void;
	badgeType: BadgeType | null;
}

export function FloatingMenuButton({ onClick, badgeType }: IFloatingMenuButtonProps) {
	const FloatingBadge = () => {
		if (badgeType !== null) {
			if (badgeType === BadgeType.warning)
				return <Badge className="floating-menu__badge--warning" />;
			if (badgeType === BadgeType.error)
				return <Badge className="floating-menu__badge--error" />;
		}

		return null;
	};
	return (
		<>
			<span className="floating-menu__button">
				<IconButton iconName="dots-vertical" onClick={onClick} />
			</span>
			<FloatingBadge />
		</>
	);
}
